/* global G */
import asObject from 'lib/sequence/component/children/asObject'
import { get, set } from 'lib/sequence/component/state/value'
import { disable } from 'lib/sequence/component/state/disabled'
import listTicketFilterAssignee from 'app/_shared/events/collection/listTicketFilterAssignee'
import index from 'app/ticket/action/list/index'

/**
 * ServiceItem editing and creation.
 *
 * Toggles the visibility and mapping of fields depending on whether the service item should just be
 * saved for a ticket or as an individual entity in the database and whether there is already an
 * entity selected.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => {
  const { filter } = asObject(component[G.CHILDREN])
  const { status: statusField, assignee: assigneeField } = asObject(filter[G.CHILDREN])

  // assignee to "me"
  const assigneeSelection = listTicketFilterAssignee(module, component, null)
  const option = assigneeSelection[2]
  set(assigneeField, [option])
  disable(assigneeField)

  // status
  !get(statusField) && set(statusField, 1)

  await index(module)(component)(args)

  return args
}
